import React from 'react';
import OutstandingListingWrapper from './OutstandingListingWrapper';
import FinanceApprovalPageHeader from 'views/pages/manage/unAssigned/studentFinanceApproval/components/ApprovalPageHeader';

const OutstandingDashboard = ({ userPermissions }) => {
    return (
    <div>
      <FinanceApprovalPageHeader
        heading='Outstanding module'
        subHeading={'Here you can find list of all students having outstanding amount'}
      />
      <OutstandingListingWrapper userPermissions={userPermissions}  />
    </div>
    );
}
export default OutstandingDashboard;